import React, { useEffect } from 'react';
import Dialog from '#lib/components/dialog.jsx';
import Button from '#lib/components/button.jsx';
import useUnlink from '#src/@connections/use-unlink.js';

export default function UnlinkModal(props) {
    const { isShown, onClose, id } = props;
    const unlinkMutationOptions = {
        mutationKey: [id],
        onSuccess: (res) => {
            res.ok ? console.log(_t.global.success()) : console.error(res.errorText);
        },
        onError: () => console.error('Server Error')
    };

    const unlinkFn = useUnlink(unlinkMutationOptions);
    useEffect(() => {
        return () => onClose();
    }, [unlinkFn.isSuccess]);
    return (
        <Dialog isOpen={isShown} onClose={onClose} className="h-screen flex items-center justify-center fixed inset-4">
            <Dialog.Panel className="flex flex-col gap-4">
                <div className="pr-8">
                    <p> {_t.connections.areYouSure()} </p>
                    <Dialog.CloseButton />
                </div>
                <div>
                    <Button
                        busy={unlinkFn.isLoading}
                        onClick={() => {
                            unlinkFn.mutate(id);
                        }}
                    >
                        {_t.connections.confirmUnlink()}
                    </Button>
                </div>
            </Dialog.Panel>
        </Dialog>
    );
}
